import { simpleSignOut } from '@/hooks/useSignout';
import axios, { AxiosError } from 'axios';

type HandleErrorReturn<T> = [T, null] | [null, Error];

export type MyErrorResponse = {
  [key: string]: string;
};

export const handleFirstMessageError = (error: AxiosError<MyErrorResponse>) =>
  error.response?.data
    ? Object.values(error.response?.data || {}).map(value =>
        typeof value === 'string' ? value : (value as string[])[0]
      )[0]
    : '';

export const handleError = <T = ObjectLiteral>(
  callback: () => T
): HandleErrorReturn<T> => {
  try {
    const response = callback();
    return [response, null];
  } catch (error) {
    let errorMessage = 'Ocorreu um erro, tente novamente mais tarde!';
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    return [null, Error(errorMessage)];
  }
};

export const handleErrorAsync = async <T = ObjectLiteral>(
  callback: () => Promise<T>
): Promise<HandleErrorReturn<T>> => {
  try {
    const response = await callback();
    return [response, null];
  } catch (error) {
    let errorMessage = 'Ocorreu um erro, tente novamente mais tarde!';
    const isAxiosError = axios.isAxiosError(error);

    if (!error) {
      return [null, Error(errorMessage)];
    }

    if (!isAxiosError) {
      errorMessage = (error as Error).message;
    }

    const axiosError = error as AxiosError<MyErrorResponse>;

    if (isAxiosError || axiosError.response) {
      const errorDetail = axiosError.response?.data.detail;

      if (errorDetail) {
        errorMessage = errorDetail;
      }

      if (axiosError.response?.data && !errorDetail) {
        errorMessage = handleFirstMessageError(axiosError);
      }

      if (axiosError.response?.status === 500) {
        errorMessage =
          'Erro no servidor, verifique sua internet e tente novamente!';
      }

      if (axiosError.response?.status === 403) {
        errorMessage =
          'Você não está autorizado para fazer esse tipo de atividade';
        simpleSignOut();
      }

      if (axiosError.response?.status === 413) {
        errorMessage = 'Arquivo muito grande! Falha ao fazer upload!';
      }
    }

    return [null, Error(errorMessage)];
  }
};
